import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-canvas-badge',
  templateUrl: './canvas-badge.component.html',
  styleUrls: ['./canvas-badge.component.scss'],
})
export class CanvasBadgeComponent {
  @Input() icon = '';
  @Input() color = 'var(--grey-600)';
  @Input() tooltip = '';
  @Input() position: 'top-left' | 'top-right' = 'top-right';

  @HostBinding('class') get hostClass(): string {
    return `${this.position}${this.icon ? '' : ' dot-mode'}`;
  }

  @HostBinding('style.background') get background(): string {
    return this.icon ? 'white' : this.color;
  }
}
